<template>
    <PageLoading v-if="isLoading" />
    <div v-else class="q-pa-md">
        <q-card v-if="invitation.length" flat>
            <q-card-section class="q-pb-none">
                <i18n path="affiliations.invitation_question_text" tag="p">
                    <span place="first_name" class="text-bold">{{
                        invitation[0].sender.first_name
                    }}</span>
                    <!-- <span place="last_name" class="text-bold">{{
                        invitation[0].sender.last_name
                    }}</span> -->
                    <span place="created_at" class="text-bold">{{
                        formatDate(invitation[0].created_at)
                    }}</span>
                    <span place="client_title" class="text-bold">{{
                        invitation[0].sender.affiliations[0].clients.title
                    }}</span>
                </i18n>
                <p>{{ $t('general.do_you_accept_the_invitation') }}</p>
            </q-card-section>
            <q-card-actions align="left" class="q-px-md q-pb-md">
                <q-btn
                    class="q-px-md"
                    color="accent"
                    :ripple="false"
                    :label="$t('general.no')"
                    @click="acceptInvitation(false)"
                />
                <q-btn
                    class="q-px-md"
                    color="secondary"
                    :ripple="false"
                    :label="$t('general.yes')"
                    @click="acceptInvitation(true)"
                />
            </q-card-actions>
        </q-card>
        <q-card v-else flat>
            <q-card-section>
                <h6>{{ $t('notify.no_affiliations_invitation') }}</h6>
            </q-card-section>
        </q-card>
    </div>
</template>

<script>
import PageLoading from '@/components/PageLoading'
import notify from '@/local-shared/mixins/notify'
import affiliationsService from '@/services/modules/profile/affiliations'
import store from '@/store'
import formatDate from '@/helpers/date-time'

const loadingKeys = {
    fetchingAffiliationInvitation: 'fetching-affiliation-invitation',
    acceptingAffiliationInvitation: 'accepting-affiliation-invitation',
}

export default {
    name: 'MyAffiliationsInvitations',

    components: {
        PageLoading,
    },

    mixins: [notify],

    data() {
        return {
            invitation: [],
        }
    },

    computed: {
        isLoading() {
            return this.isFetchingAffiliationInvitation
        },

        isFetchingAffiliationInvitation() {
            return !!this.loadings.filter(
                (loading) =>
                    loading.key === loadingKeys.fetchingAffiliationInvitation
            ).length
        },

        isAcceptingAffiliationInvitation() {
            return !!this.loadings.filter(
                (loading) =>
                    loading.key === loadingKeys.acceptingAffiliationInvitation
            ).length
        },

        user() {
            return store.getters['session/user']
        },
    },

    async created() {
        await this.fetchAffiliationInvitation()
    },

    methods: {
        async fetchAffiliationInvitation() {
            this.loadingAdd(loadingKeys.fetchingAffiliationInvitation)

            let parameters = {
                filter: {
                    token: this.$route.params.token,
                    recipient_id: this.user.id,
                    accepted: false,
                    enabled: true,
                },
                relations: {
                    sender: true,
                    recipient: true,
                },
            }

            let response = await affiliationsService.requests.retrieve(
                parameters
            )

            if (response.data.status === 'success') {
                this.invitation = response.data.results
            } else {
                //TODO: error message
            }

            this.loadingRemove(loadingKeys.fetchingAffiliationInvitation)
        },

        async acceptInvitation(accepted) {
            this.loadingAdd(loadingKeys.acceptingAffiliationInvitation)

            let parameters = {
                data: [
                    {
                        id: this.invitation[0].id,
                        token: this.$route.params.token,
                        accepted: accepted,
                        client_id: this.invitation[0].client_id,
                        client_title: this.invitation[0].client_title,
                        recipient_email: this.invitation[0].recipient_email,
                        recipient_id: this.invitation[0].recipient_id,
                        sender_id: this.invitation[0].sender_id,
                        user_first_name: this.user.first_name,
                        user_last_name: this.user.last_name,
                    },
                ],
            }

            let response = await affiliationsService.requests.update(parameters)

            if (response.status === 200) {
                this.$q.notify({
                    type: 'positive',
                    message: this.$t('notify.affiliation_response_sent'),
                })
                this.$router.push({ name: 'MyAffiliations' })
            } else {
                //TODO: error message
            }
            this.loadingRemove(loadingKeys.acceptingAffiliationInvitation)
        },

        formatDate(value) {
            return value
                ? formatDate.fromServerToUxString(value, 'date', 'DD/MM/YYYY')
                : null
        },
    },
}
</script>
